export const h = {
	quantity: "disponibile",
	brand: "marca",
	sku: "SKU",
	model: "modello",
	addCart: "Aggiungi al carrello",
	buyNow: "Compra ora",
	productDetail: "Dettagli prodotto",
	attribute: "Attribute",
	quantityExits: "in stock",
	quantityNone: "esaurito",

	// 账单页面
	email: "Email",
	errorEmail: "Inserisci un'email valida",
	contact: 'Contatti',
	sippingAddress: 'Indirizzo di spedizione',
	name: "Nome",
	nameError: "Inserisci il nome",
	address1: "Indirizzo 1",
	address1Error: "Inserisci l'indirizzo 1",
	address2: "Indirizzo 2",
	emailCode: "Codice postale",
	phone: "Numero di telefono",
	city: "Città",
	cityError: "Inserisci la città",
	country: "Paese",
	countryError: "Inserisci il paese",
	province: "Provincia",
	provinceError: "Inserisci la provincia",
	payWay: "Metodo di pagamento",
	sendWay: "Metodo di spedizione",
	loginText: "Accedi / Registrati",
	cartNum: "Totale carrello",
	orderRemarks: "Note dell'ordine",
	discountCode: "Inserisci il codice sconto",
	apply: "Applica",
	submitOrder: "Invia ordine",

	classify: "Categoria",
	price: "Prezzo",
	allNum: "Totale",
	defaultTit: "Predefinito",
	salesLowToHigh: "Vendite (Basso - Alto)",
	salesHighToLow: "Vendite (Alto - Basso)",
	nameAtoZ: "Nome (A - Z)",
	nameZtoA: "Nome (Z - A)",
	priceLowtoHeight: "Prezzo (Basso - Alto)",
	priceHeighttoLow: "Prezzo (Alto - Basso)",
	selectClassfiy: "Seleziona categoria",
	goodCart: "Carrello",
	checkout: "Checkout",
	pay: "Pagamento",
	goods: "Prodotto",
	num: "Quantità",
	total: "Subtotale",
	action: "Azione",
	del: "Elimina",
	priceTotal: "Totale",
	all: "Tutti",
	selectd: "Selezionato",
	goCheckout: "Vai al checkout",
	linkGoods: "Prodotti correlati",
	noData: "Nessun dato disponibile",
	myOrder: "I miei ordini",
	changeUserInfo: "Modifica informazioni personali",
	changePassword: "Cambia password",
	myAddress: "I miei indirizzi",
	myWishlist: "La mia lista desideri",
	myRmas: "Assistenza clienti",
	userCommission: "Commissione membro",
	commissionUsers: "Relazioni membri",
	loginOut: "Esci",
	orderId: "Numero ordine",

	lookDetail: "Vedi dettagli",
	saleService: "Richiedi assistenza",
	confirmReceivedGoods: "Conferma ricezione",
	goPay: "Vai al pagamento",
	cancelOrder: "Annulla ordine",

	orderDetail: "Dettagli ordine",
	created_at: "Data creazione",
	status_format: "Stato ordine",
	total_format: "Importo ordine",
	payment_method_name: "Metodo di pagamento",
	shipping_method_name: "Metodo di spedizione",

	addressInfo: "Informazioni indirizzo",
	name: "Nome",
	address: "Indirizzo",
	payGoods: "Prodotti ordinati",

	sendCompany: "Corriere",
	sendNum: "Numero tracking",
	updateTime: "Data aggiornamento",
	memo: "Note",
	payOrderAddress: "Indirizzo fatturazione",
	allOrder: "Tutti gli ordini",
	waitPay: "In attesa di pagamento",
	waitSend: "In attesa di spedizione",
	waitReceiving: "In attesa di consegna",
	completed: "Completato",
	confirm: "Conferma",
	tips: "Suggerimento",
	cancel: "Annulla",
	changeHeadImg: "Cambia immagine profilo",
	uploadTit: "Carica immagine JPEG/PNG. Dimensione consigliata 300 x 300.",
	imgSizeTips: "L'immagine non può superare 2 MB!",
	imgTypeTips: "Solo formati JPG/PNG!",
	serviceType: "Tipo servizio",
	returnNum: "Quantità reso",
	isOpend: "Confezione aperta?",
	returnReason: "Motivo reso",
	yes: "Sì",
	no: "No",
	returnGoods: "Reso",
	exchange: "Cambio",
	repair: "Riparazione",
	reissue: "Rispedizione",
	refund: "Solo rimborso",
	returnNumError: "Inserisci quantità reso",

	oldPassword: "Vecchia password",
	newPassword: "Nuova password",
	confirmNewPassword: "Conferma nuova password",

	wishlist: "Rimuovi da lista desideri",
	look: "Visualizza",
	opendPkg: "Confezione aperta",
	img: "Immagine",
	afterSales: "Dettagli assistenza",

	balance: "Saldo disponibile",
	waitAmount: "Importo in sospeso",
	withdrawaled: "Prelevato",
	withdrawal: "Prelievo",
	allCommission: "Commissione totale",
	startTime: "Data inizio",
	endTime: "Data fine",
	search: "Cerca",

	rebateLevel: "Livello commissione",
	CommissionRate: "Percentuale commissione",
	commission: "Commissione",
	settlementStatus: "Stato liquidazione",
	time: "Data",
	WithdrawalAmount: "Importo prelievo",
	peleaseSelect: "Seleziona",
	withdrawalUser: "Conto prelievo",
	peleaseIpt: "Inserisci",
	submitSuccess: "Inviato con successo",
	shareLink: "Condividi link",
	superior: "Mio superiore diretto",
	wu: "Nessuno",
	subordinate: "Miei subordinati",
	addTime: "Data iscrizione",
	userAccount: "Account",
	recommendationCode: "Codice referral",
	copySuccess: "Copiato con successo",
	subPay: "Invia pagamento",
	iptCardholder_Name: "Inserisci nome intestatario carta",

	copy: "copia",

	"home": "Home",
	"categoriesPage": "Categorie",
	"brandsPage": "Marchi",
	"brandsPageList": "Prodotti di marca",
	"productsPage": "Prodotti",
	"wishlistPage": "La mia lista dei desideri",
	"accountPage": "I miei ordini",
	"cartsPage": "Carrello",
	"checkoutPage": "Checkout",
	"passwordPage": "Cambia password",
	"editPage": "Modifica informazioni",
	"addressesPage": "Modifica indirizzo",
	"rmasPage": "Relazioni di affiliazione",
	"commissionPage": "Commissione membro",
	"success_order_checkoutPage": "Pagamento ordine",
	"page_categoriesPage": "Categorie articoli",
	"userloginPage": "Accesso",
	"pagesPage": "Articoli",

	hotGoods: "Prodotti popolari",
	newGoods: "Nuovi arrivi",
	visitGoods: "Più visti",
	allGoods: "Tutti i prodotti",
	evaluation: "Recensioni",

	"first_name": "Cognome",
	"first_nameError": "Inserisci il tuo cognome",
	"last_name": "Nome",
	"last_nameError": "Inserisci il tuo nome",

	"comment": "Contenuto",
	"noContent": "Ancora nessun commento",
	"author": "Autore",
	"scoreNum": "Valutazione",
	"commentTit": "Commenti",

	send: "Invia",

	noPayWay: "Nessun metodo di pagamento disponibile",
	noTransportation: "Nessun metodo di spedizione disponibile",
	
	"tkyouorder": "Grazie per il tuo ordine",
	  "orderDate": "Data dell'ordine",
	  "ordeAmount": "Importo dell'ordine",
	  "paymentAddress": "Indirizzo di pagamento",
	  "zipCode": "Codice postale"

}